<div class="container-fluid m-0 p-0">
  <div class="row">
    <div class="col-12">
      <div class="bg-white border pt-3 my-4">
        <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "EXAMS_REPORTS" |
          translate
          | titlecase }}</h5>
        <app-loader [show]="showLoader"></app-loader>
        <br>
        <div id="accordion" *ngIf="showLoader==false">
          <div class="card">
            <div id="collapseOne">
              <div class=" card-body">
                <form [formGroup]="searchForm" (change)="searchFormChange()" (submit)="searchFormSubmit()">
                  <div class="row">
                    <div class="col-md-3 form-group px-md-5 mb-1">
                      <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase
                        }}</label>
                      <select class="form-control custom-select" formControlName="year" (change)="getYearSemesters()">
                        <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                          }}
                        </option>
                        <option *ngFor="let field of years" [ngValue]="field.id">
                          {{
                          (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                          }}
                        </option>
                      </select>
                      <div class="alert alert-danger py-1 mt-1"
                        *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                      </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1">
                      <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                      <select class="form-control custom-select" formControlName="semester" (change)="getBatches()">
                        <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                          }}
                        </option>
                        <option *ngFor="let field of semesters" [ngValue]="field.id">
                          {{
                          (globals.lang == 'ar')? field?.semesterNameAr :
                          field?.semesterNameEn
                          }}
                        </option>
                      </select>
                      <div class="alert alert-danger py-1 mt-1"
                        *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                      </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1">
                      <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                      <select class="form-control custom-select" formControlName="batch" (change)="getBatchGroups()">
                        <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                          }}
                        </option>
                        <option *ngFor="let field of batches" [ngValue]="field.id">
                          {{
                          (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                          }}
                        </option>
                      </select>
                      <div class="alert alert-danger py-1 mt-1"
                        *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                      </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1">
                      <label class="font-bold"> {{ "GROUP" | translate | titlecase }}</label>
                      <select class="form-control custom-select" formControlName="group"
                        (change)="getStudentsByGroup()">
                        <option value="" [selected]="true">{{ "SELECT" | translate |
                          titlecase
                          }}</option>
                        <option *ngFor="let field of groups" value="{{field.id}}">
                          {{(globals.lang == 'ar')? field.egroupNameAr :
                          field.egroupNameEn}} - ({{field.egroupCode}})</option>
                      </select>
                      <div class="alert alert-danger py-1 mt-1"
                        *ngIf="searchForm.controls.group.touched && searchForm.controls.group.invalid && searchForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 form-group px-md-5 mb-1">
                      <label class="font-bold"> {{ "SUBJECT" | translate | titlecase }}</label>
                      <select class="form-control custom-select" formControlName="subject"
                        (change)="getSubjAssessmentUnits()">
                        <option value="" [selected]="true">{{ "SELECT" | translate |
                          titlecase
                          }}</option>
                        <option *ngFor="let field of subjects" value="{{field.id}}">
                          {{(globals.lang == 'ar')? field.subjectNameAr : field.subjectNameEn}}</option>
                      </select>
                      <div class="alert alert-danger py-1 mt-1"
                        *ngIf="searchForm.controls.subject.touched && searchForm.controls.subject.invalid && searchForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                      </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1">
                      <label class="font-bold"> {{ "ASSESSMENT_UNITS" | translate | titlecase }}</label>
                      <select class="form-control custom-select" formControlName="assessmentUnit">
                        <option value="" [selected]="true">{{ "SELECT" | translate |
                          titlecase
                          }}</option>
                        <option *ngFor="let field of assessmentUnits" value="{{field.asesid}}">
                          {{(globals.lang == 'ar')? field.subjAsesNameAr : field.subjAsesNameEn}}</option>
                      </select>
                      <div class="alert alert-danger py-1 mt-1"
                        *ngIf="searchForm.controls.assessmentUnit.touched && searchForm.controls.assessmentUnit.invalid && searchForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                      </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1">
                      <label class="font-bold"> {{ "STUDENT" | translate | titlecase }}</label>
                      <select class="form-control custom-select" formControlName="student">
                        <option value="" [selected]="true">{{ "SELECT" | translate |
                          titlecase
                          }}</option>
                        <option *ngFor="let field of allstudents" value="{{field.id}}">
                          {{field.id.toString() + " - " + ((globals.lang == 'ar')? field.fullNameAr :
                          field.fullNameEn)}}</option>
                      </select>
                      <div class="alert alert-danger py-1 mt-1"
                        *ngIf="searchForm.controls.student.touched && searchForm.controls.student.invalid && searchForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                      </div>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 1">
                        {{ "STUDENT_SCORES" | translate | titlecase }}</button>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 2">
                        {{ "STUDENT_SCORES_GPA" | translate | titlecase }}</button>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 3">
                        {{ "Cumulative Score Report [MOHE 7]" | translate | titlecase }}</button>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 4">
                        {{ "Mohe Graduate Transcript Report" | translate | titlecase }}</button>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 5">
                        {{ "MOHE Graduate Transcript Semester Report" | translate | titlecase }}</button>
                    </div>
                    <!-- <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 2">
                        {{ "ACADEMIC_CLINICAL_WARNINGS" | translate | titlecase }}</button>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 3">
                        {{ "EXAMINATION_EXTRACT" | translate | titlecase }}</button>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 4">
                        {{ "COHORT_ONGOING" | translate | titlecase }}</button>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="submit" class="btn btn-primary" (click)="currentReportNumber = 5">
                        {{ "CUMULATIVE_PERFORMANCE" | translate | titlecase }}</button>
                    </div> -->
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <br>
        <!-- <div class="row" *ngIf="!showLoader">
                  <div class="col-sm-1">
                      <button (click)="generateExcel()" class="btn" style="height:auto"><span
                              style="font-size: 2em; color: green;"><i
                                  class="fas fa-file-excel fa-sm"></i></span></button>
                  </div>
                  <div class="col-md-3 form-group px-md-5 mb-1">
                      <label class="font-bold"> {{ "STUDENT_STATUS" | translate | titlecase }}</label>
                      <select class="form-control custom-select" [(ngModel)]="newStudentStatus">
                          <option value="present" [selected]="true">{{ "PRESENT" | translate | titlecase}}</option>
                      </select>
                  </div>
                  <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                      <button type="button" class="btn btn-success" (click)="updateStudentStatus()"><i
                              class="fas fa-save"></i>{{
                          "UPDATE" | translate | titlecase }}</button>
                  </div>
              </div> -->
        <br>
        <div class="table-responsive py-3" style="padding: 10px;" *ngIf="!generatingReport && students.length >= 1">
          <div class="row">
            <div class="col-sm-1">
              <button (click)="XLExport('datatable_report')" class="btn" style="height:auto"><span
                  style="font-size: 2em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span></button>
            </div>
            <!-- <div class="col-sm-1">
              <button (click)="XLExport('datatable_report')" class="btn" style="height:auto"><span
                  style="font-size: 2em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span></button>
            </div> -->
          </div>
          <br />

          <div class="table-responsive py-3" *ngIf="!reportHasImage">
            <table *ngIf="students.length >= 1" class="table table-bordered" id="datatable_report">
              <!-- <caption>{{ "ACADMIC_YEAR" | translate | titlecase}}: {{" " + currentYearText}} - {{ "SEMESTER" | translate | titlecase }}: {{" " + currentSemesterText}}</caption> -->
              <thead>
                <tr>
                  <th class="text-center" [attr.colspan]="students[1]?.length - 1">{{ "ACADMIC_YEAR" | translate |
                    titlecase}}: {{" " +
                    currentYearText}} - {{ "SEMESTER" | translate | titlecase }}: {{" " + currentSemesterText}} - {{
                    "BATCH" | translate | titlecase }}: {{" " + currentBatchText}}</th>
                </tr>
                <tr>
                  <ng-container *ngFor="let res of ScheduleHeader let headerIndex = index">
                    <th *ngIf="headerIndex > 0" [attr.colspan]="res.colspan" class="text-center">{{res.data}}</th>
                  </ng-container>
                </tr>
                <tr *ngIf="cumulativePerformanceReport">
                  <ng-container *ngFor="let res of ScheduleHeader1 let headerIndex = index">
                    <th *ngIf="headerIndex > 0" [attr.colspan]="res.colspan" class="text-center">{{res.data}}</th>
                  </ng-container>
                </tr>
                <tr *ngIf="cumulativePerformanceReport">
                  <ng-container *ngFor="let res of ScheduleHeader2 let headerIndex = index">
                    <th *ngIf="headerIndex > 0" [attr.colspan]="res.colspan" class="text-center">{{res.data}}</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of students let i = index">
                  <ng-container *ngFor="let colm of data let dataIndex = index">
                    <td *ngIf="dataIndex>0" [ngStyle]="{backgroundColor: (colm.color)? colm.color : ''}">
                      {{colm.data}}
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-responsive py-3" *ngIf="reportHasImage">
            <table *ngIf="students.length >= 1" class="table table-bordered" id="datatable_report">
              <thead>
                <tr>
                  <th class="text-center" [attr.colspan]="students[1].length - 1">{{ "ACADMIC_YEAR" | translate |
                    titlecase}}: {{" " +
                    currentYearText}} - {{ "SEMESTER" | translate | titlecase }}: {{" " + currentSemesterText}} - {{
                    "BATCH" | translate | titlecase }}: {{" " + currentBatchText}}</th>
                </tr>
                <tr>
                  <!-- <th *ngFor="let res of ScheduleHeader let headerIndex = index" [ngClass]="{'notExport': headerIndex == 0}">{{res}}</th> -->
                  <ng-container *ngFor="let res of ScheduleHeader let headerIndex = index">
                    <!-- <th *ngIf="headerIndex > 0" [attr.colspan]="res.colspan" class="text-center">{{res.data}}</th> -->
                    <th *ngIf="headerIndex > 0" [attr.colspan]="res.colspan" class="text-center"
                      [ngClass]="{'notExport': headerIndex == 0}">{{res.data}}</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of students let i = index">
                  <!-- <td *ngFor="let colm of data let dataIndex = index" [ngStyle]="{color: (colm.includes('NE')) ? 'red' : 'black', 'font-weight': 'bold'}" > -->
                  <ng-container *ngFor="let colm of data let dataIndex = index">
                    <td *ngIf="dataIndex>0">
                      <img *ngIf="(dataIndex == 4 && i>0); else elseNotImage" src="{{photoPath+ colm}}"
                        (error)="errorHandler($event)" alt="Photo" class="img-fluid" width="70" id="userImageTag"
                        (load)="getBase64($event, i)" crossOrigin='Anonymous'>
                      <!-- <ng-template #elseNotImage>{{(isNumber(colm) && colm < 75)? (colm + "%" + " - NE(A)") : ((isNumber(colm))? (colm + "%") : colm)}}</ng-template> -->
                      <ng-template #elseNotImage>{{colm}}</ng-template>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
